import headerStyles from "../../styles/header.module.css";
import TimestampChip from "./Clock";
import { ReactComponent as HomeIcon } from "../../assets/icons/bagstage_home.svg";
import IconLinkButton from "./buttons/IconLinkButton";
import { useTranslation } from "react-i18next";
import TimeService from "../../service/timeService";

export default function Header() {
  const { t } = useTranslation();

  return (
    <div className={headerStyles.header}>
      <div className={headerStyles.headerSection}>
        <IconLinkButton
          to={window._env_.REACT_APP_HOME_PAGE_URL!}
          icon={<HomeIcon />}
        />
      </div>
      <div className={headerStyles.headerSection}>
        <p className={headerStyles.dateTimeText}>
          {TimeService.formattedDateForHeader(t)}
        </p>
        <TimestampChip />
      </div>
    </div>
  );
}
